export default __webpack_public_path__ + "static/media/banjo.60f3374d.png";